import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { SharedService } from '../../../@core/services/shared.service'
import { ITurnInfo, IWorkingDate, WorkingService } from '../../../@core/services/working.service'
import { NbDialogRef } from '@nebular/theme'
import _ from 'lodash'

@Component({
    templateUrl: './tip-distribution.component.html',
    styleUrls: ['./tip-distribution.component.scss'],
    selector: 'app-tip-distribution',
})
export class TipDistributionComponent implements OnInit, AfterViewInit {
    inCash: boolean = false
    totalTipAmt: number = null
    turnList: Array<ITurnInfo> = []
    selectedCount: number = 0
    totalSeparated: number = 0
    @Input() workingData: IWorkingDate
    @ViewChild('amtInput', { static: false }) amtRef: ElementRef

    constructor(
        public sharedService: SharedService,
        public workingService: WorkingService,
        private dialogRef: NbDialogRef<any>
    ) {}
    ngAfterViewInit() {
        this.amtRef?.nativeElement?.focus()
    }
    ngOnInit() {
        for (const e of this.workingData.employees) {
            this.turnList = this.turnList.concat(
                e.turns
                    .filter((t) => t.paymentStatus === 'pending')
                    .map((t) => {
                        return {
                            ...t,
                            optionalData: {
                                employee: e.employee,
                                selected: false,
                            },
                        }
                    })
            )
        }
        this.turnList = _.orderBy(this.turnList, 'id', 'desc')
    }
    onItemClick(item) {
        this.turnList.find((e) => e.id === item.id).optionalData.selected = !item.optionalData.selected
        this.separateTips()
    }
    onTotalTipAmtChanged() {
        this.separateTips()
    }
    onRoundToOneChanged() {
        this.separateTips()
    }
    onOk() {
        const turns = this.turnList
            .filter((e) => e.optionalData.selected)
            .map((e) => {
                return {
                    id: e.id,
                    tip: this.inCash ? 0 : e.tip,
                }
            })
        this.workingService.updateMultipleTips(this.workingData.workingDate, turns, true).subscribe((res) => {
            if (res) {
                this.dialogRef.close(true)
            }
        })
    }
    onCancel() {
        this.dialogRef.close()
    }
    roundAmt(amt) {
        return Math.round(amt * 100) / 100
    }
    separateTips() {
        this.selectedCount = 0
        this.totalSeparated = 0
        this.totalTipAmt = this.roundAmt(this.totalTipAmt)
        const totalTurnsAmt = this.turnList
            .filter((e) => e.optionalData.selected)
            .reduce((previousValue, currentValue) => previousValue + currentValue.amt, 0)
        // separate
        for (const t of this.turnList) {
            if (!t.optionalData.selected) {
                t.tip = 0
                continue
            }
            this.selectedCount += 1
            t.tip = this.roundAmt((t.amt / totalTurnsAmt) * this.totalTipAmt) || 0
            if (this.inCash) {
                t.tip = Math.round(t.tip)
            }
            this.totalSeparated += t.tip
        }
        // no turns separated
        if (this.totalSeparated === 0) {
            return
        }
        // re check
        if (this.totalSeparated === this.totalTipAmt) {
            return
        }
        let diffAmt = this.roundAmt(this.totalTipAmt - this.totalSeparated)
        if (this.inCash) {
            diffAmt = Math.round(diffAmt)
        }
        console.log('Tips:diffAmt', diffAmt)
        if (diffAmt !== 0) {
            let sorted
            if (diffAmt > 0) {
                // plus to smallest turn
                sorted = _.orderBy(
                    this.turnList.filter((e) => e.optionalData.selected && e.amt > 0),
                    ['tip', 'amt'],
                    ['asc', 'desc']
                )
            } else {
                // subtract from biggest turn
                sorted = _.orderBy(
                    this.turnList.filter((e) => e.optionalData.selected && e.amt > 0),
                    ['tip', 'amt'],
                    ['desc', 'asc']
                )
            }
            for (const t of this.turnList) {
                if (t.id === sorted[0].id) {
                    console.log(`add ${diffAmt} to turn ${t.amt}`)
                    t.tip = this.roundAmt(t.tip + diffAmt)
                    break
                }
            }
        }
    }
}
